import React from 'react';
import { statusOptions } from '@typings/ResidentTypes';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getPatientACPTagColorAndText } from './utils';
// eslint-disable-next-line import/no-cycle
import { TableData } from './ResidentProfileHeader';

interface PatientNotesDetailsTableProps {
  slug: string;
  tableData: TableData;
  scrollToPrognosis: () => void;
}

const PatientNotesDetailsTable: React.FC<PatientNotesDetailsTableProps> = ({
  slug,
  tableData,
  scrollToPrognosis,
}) => {
  const {
    patientFullName,
    careStatus,
    acpStatus,
    acpReviewDate,
    pigStatus,
    address,
    nfkFullName,
    nfkPhoneNumber,
  } = tableData;

  const navigate = useNavigate();

  const handleShowAcpReviewDate = () => {
    const handleClickAcpReviewDate = () => {
      navigate(`/patient/${slug}`, {
        state: { currentStep: 3, scrollTo: 'acpReviewDateForm' },
      });
    };
    let displayText = '';
    if (acpReviewDate) {
      if (
        typeof acpReviewDate === 'string' &&
        acpReviewDate.toLocaleLowerCase() === 'not relevant'
      ) {
        displayText = 'Not relevant';
      } else {
        displayText = dayjs(acpReviewDate).format('DD/MM/YYYY');
      }
      return (
        <div onClick={() => handleClickAcpReviewDate()}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href=""
            className="govuk-link govuk-!-font-weight-bold govuk-link--no-visited-state"
          >
            {displayText}
          </a>
        </div>
      );
    }
    return '';
  };

  const handleShowCareStatus = () => {
    const handleClickCareStatus = () => {
      navigate(`/patient/${slug}`, {
        state: { currentStep: 2 },
      });
    };
    if (careStatus) {
      return (
        <div onClick={() => handleClickCareStatus()}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href="#"
            className="govuk-link govuk-!-font-weight-bold govuk-link--no-visited-state"
          >
            {statusOptions.find(status => status.value === careStatus)?.label
              ? statusOptions.find(status => status.value === careStatus)?.label
              : careStatus}
          </a>
        </div>
      );
    }
    return '';
  };

  const handleClickOnNokName = (e: any) => {
    e.preventDefault();
    navigate(`/patient/${slug}`, {
      state: { currentStep: 1, scrollTo: 'nfkDetails' },
    });
  };
  const handleClickAddress = (e: any) => {
    e.preventDefault();
    navigate(`/patient/${slug}`, {
      state: { currentStep: 1, scrollTo: 'currentAddress' },
    });
  };

  return (
    <table className="govuk-table mt-8">
      <tbody className="govuk-table__body">
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">Name</td>
          <td className="govuk-table__cell">
            <p className="govuk-body govuk-!-font-weight-bold govuk-!-static-margin-0">
              <a
                href={`/patient/${slug}`}
                className="govuk-link govuk-link--no-visited-state"
              >
                {patientFullName}
              </a>
            </p>
          </td>
        </tr>
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">Care status</td>
          <td className="govuk-table__cell">{handleShowCareStatus()}</td>
        </tr>
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">ACP status</td>

          <td className="govuk-table__cell">
            {(() => {
              const { color, displayText } =
                getPatientACPTagColorAndText(acpStatus);
              return (
                <strong
                  className={`govuk-tag ${color ? `govuk-tag--${color}` : ''}`}
                >
                  {displayText}
                </strong>
              );
            })()}
          </td>
        </tr>
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">ACP review date</td>
          <td className="govuk-table__cell">{handleShowAcpReviewDate()}</td>
        </tr>
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">PIG status</td>
          <td className="govuk-table__cell">
            <div
              onClick={e => {
                e.preventDefault();
                scrollToPrognosis();
              }}
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href=""
                className="govuk-link govuk-!-font-weight-bold govuk-link--no-visited-state"
              >
                {pigStatus}
              </a>
            </div>
          </td>
        </tr>
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">Address</td>
          <td className="govuk-table__cell">
            <div onClick={e => handleClickAddress(e)}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href=""
                className="govuk-link govuk-!-font-weight-bold govuk-link--no-visited-state"
              >
                {address}
              </a>
            </div>
          </td>
        </tr>
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">Next of Kin</td>
          <td className="govuk-table__cell">
            <div onClick={e => handleClickOnNokName(e)}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href=""
                className="govuk-link govuk-!-font-weight-bold govuk-link--no-visited-state"
              >
                {nfkFullName}
              </a>
            </div>
          </td>
        </tr>
        <tr className="govuk-table__row">
          <td className="govuk-table__cell">Next of Kin number</td>
          <td className="govuk-table__cell">
            <p className="govuk-body underline govuk-!-margin-0 govuk-!-font-weight-bold">
              {nfkPhoneNumber ? (
                <a href={`tel:${nfkPhoneNumber}`}>{nfkPhoneNumber}</a>
              ) : (
                ''
              )}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default PatientNotesDetailsTable;
